<app-toaster class="toaster" [config]="toasterService.toaster"></app-toaster>

<div class="container payroll-slab-container">
  <div class="row">
    <div class="col-md-offset-1 col-md-10">
      <h2 class="page-title">{{ isViewMode ? 'View Slab' : (actionTitle === 'Duplicate' ? 'Duplicate Slab' : (isGeoSlabPage ? 'Create Geo Slab' : 'Create Slab')) }}</h2>
      <div *ngIf="isApprovalPreview" style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px;">
        <p class="help-block" style="margin: 0;">
          Approval request status: <strong>{{ approvalRequestStatusDisplay }}</strong>
        </p>
        <div style="text-align: right;">
          <p *ngIf="approvalRequestCreatedBy" class="help-block" style="margin: 0 0 4px 0;">
            Requested by: <strong>{{ approvalRequestCreatedBy }}</strong>
          </p>
          <p *ngIf="isApproved && approvalRequestApprovedBy" class="help-block" style="margin: 0;">
            Approved by: <strong>{{ approvalRequestApprovedBy }}</strong>
          </p>
        </div>
      </div>

      <ng-template #fallbackShiftInfoText>
        <p class="fallback-shift-info-copy">
          The selected shift will not be assigned to any captain. Instead, the slab created for this shift will serve as
          a fallback in cases where no slabs are defined for a captain.
        </p>
      </ng-template>

      <!-- ─── BASIC FIELDS ───────────────────────────────────────────────── -->

      <!-- Shift Type -->
      <div class="form-group" *ngIf="!isViewMode && !isGeoSlabPage">
        <label class="control-label col-xs-3">Shift : *</label>
        <div class="col-xs-9">
          <label class="radio-inline">
            <input type="radio" name="shiftSelection" [(ngModel)]="shiftSelection" value="existing"> Existing
          </label>
          <label class="radio-inline" style="margin-left:20px">
            <input type="radio" name="shiftSelection" [(ngModel)]="shiftSelection" value="new"
                   (change)="router.navigate(['/shift/create'])"> New
          </label>
        </div>
      </div>

      <!-- Default Slab -->
      <div class="form-group default-slab-option" *ngIf="!isGeoSlabPage">
        <div class="control-label col-xs-3 default-slab-label-col">
          <span for="isFallbackSlab">Fallback Slab</span>
          <button type="button" class="default-slab-info-trigger" *ngIf="!isViewMode"
                  matTooltip="Creates a fallback slab at service detail level. When there is no slab for a given service detail & shift, earnings computation uses this fallback slab for the captain"
                  matTooltipPosition="above"
                  matTooltipClass="default-slab-tooltip"
                  aria-label="What is Fallback Slab?">
            <span class="default-slab-info-icon" aria-hidden="true">i</span>
          </button>
        </div>
        <div class="col-xs-9 default-slab-control">
          <label class="default-slab-checkbox-wrap"
                 [ngClass]="{'view-mode-unchecked': isViewMode && !isFallbackSlab}"
                 for="isFallbackSlab">
            <input type="checkbox" id="isFallbackSlab" name="isFallbackSlab" [(ngModel)]="isFallbackSlab"
                   (change)="onDefaultSlabToggle()" class="default-slab-input"
                   [disabled]="isViewMode">
            <span class="default-slab-box"></span>
            <span class="default-slab-label">Create Fallback Slab with Default Shift</span>
          </label>
        </div>
      </div>

      <!-- City -->
      <div class="form-group">
        <label class="control-label col-xs-3">City : *</label>
        <div class="col-xs-9">
          <ng-select [(ngModel)]="selectedCities" name="city" placeholder="City"
                      (change)="onCityChange($event)" [clearable]="false"
                      [disabled]="isViewMode"
                      style="font-size: 16px;">
            <ng-option *ngFor="let city of cities" [value]="city.displayName">{{ city.displayName }}</ng-option>
          </ng-select>
        </div>
      </div>

      <!-- Mode (populated from serviceCatalogue after city is selected) -->
      <div class="form-group">
        <label class="control-label col-xs-3">Mode : *</label>
        <div class="col-xs-9">
          <ng-select *ngIf="!isViewMode" [(ngModel)]="selectedMode" name="selectedMode"
                      placeholder="Mode"
                      (change)="onModeChange()" [clearable]="false"
                      [disabled]="!selectedCities || isViewMode"
                      style="font-size: 16px;">
            <ng-option *ngFor="let m of modes" [value]="m.id">{{ m.name }}</ng-option>
          </ng-select>
          <input *ngIf="isViewMode" type="text" class="form-control" [value]="getViewModeDisplayText()" readonly>
        </div>
      </div>

      <!-- Services -->
      <div class="form-group">
        <label class="control-label col-xs-3">Services : *</label>
        <div class="col-xs-9">
          <ng-select *ngIf="!isViewMode" [(ngModel)]="params.serviceTypes" name="serviceTypes"
                      placeholder="Services"
                      [multiple]="true" (change)="servicesChanged()" [clearable]="false"
                      [disabled]="!selectedMode || isViewMode"
                      style="font-size: 16px;">
            <ng-option *ngFor="let service of services" [value]="service._id">{{ service.service.name }}{{ !service.active || !service.service.active ? ' (Inactive)' : '' }}</ng-option>
          </ng-select>
          <input *ngIf="isViewMode" type="text" class="form-control" [value]="getViewModeServiceDisplayText()" readonly>
        </div>
      </div>

      <!-- Layer type (Geo Slab). Only hotspot for now; more types later. -->
      <div class="form-group" *ngIf="isGeoSlabPage">
        <label class="control-label col-xs-3">Layer : *</label>
        <div class="col-xs-9">
          <ng-select [(ngModel)]="selectedGeoLayerType" name="geoLayerType"
                     placeholder="Layer"
                     (change)="onGeoLayerTypeChange()" [clearable]="false"
                     [disabled]="isViewMode"
                     style="font-size: 16px;">
            <ng-option *ngFor="let layerType of geoLayerTypes" [value]="layerType.id">{{ layerType.name }}</ng-option>
          </ng-select>
        </div>
      </div>

      <!-- Hotspot for the selected layer type -->
      <div class="form-group" *ngIf="isGeoSlabPage">
        <label class="control-label col-xs-3">{{ getGeoLayerTypeDisplayName() }} : *</label>
        <div class="col-xs-9">
          <div *ngIf="layersLoading" class="alert alert-info" role="status">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading {{ getGeoLayerTypeDisplayName().toLowerCase() }}s...
          </div>
          <div *ngIf="layersError" class="alert alert-warning" role="alert">
            <p>{{ layersErrorMessage }}</p>
            <button type="button" class="btn btn-primary" (click)="retryGeoSlabLayers()">Retry</button>
          </div>
          <ng-select *ngIf="!layersError"
                     [(ngModel)]="selectedLayer" name="layerId"
                     placeholder="Select {{ getGeoLayerTypeDisplayName().toLowerCase() }}"
                     (change)="onGeoSlabLayerChange()" [clearable]="false"
                     [disabled]="!selectedCities || !selectedMode || !selectedGeoLayerType || layersLoading || isViewMode"
                     style="font-size: 16px;">
            <ng-option *ngFor="let layer of layers" [value]="layer.id">{{ layer.name }}</ng-option>
          </ng-select>
          <small class="text-muted">{{ getGeoLayerTypeDisplayName() }}s for the selected city and mode</small>
        </div>
      </div>

      <!-- Existing Geo Slab from config-manager for this city and hotspot -->
      <div class="alert alert-warning existing-geo-slab-box"
           *ngIf="isGeoSlabPage && selectedCities && selectedLayer"
           role="status">
        Existing config for this hotspot and city will be updated with the latest slab.
        <div *ngIf="existingGeoSlabsLoading" class="existing-slab-loading">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading existing Geo Slab...
        </div>
        <div class="existing-slab-list" *ngIf="!existingGeoSlabsLoading && existingGeoSlabs.length">
          <div class="existing-slab-list-header">
            Existing Geo Slab
          </div>
          <div class="existing-slab-list-scroll">
            <div class="existing-slab-item" *ngFor="let slab of existingGeoSlabs">
              <ng-container *ngTemplateOutlet="existingGeoSlabDetails; context: { $implicit: slab }"></ng-container>
            </div>
          </div>
        </div>
        <p class="existing-slab-empty" *ngIf="!existingGeoSlabsLoading && !existingGeoSlabs.length">
          No config-manager Geo Slab for this city and hotspot.
        </p>
      </div>
      <div class="form-group" *ngIf="!isGeoSlabPage && shiftSelection === 'existing'">
        <label class="control-label col-xs-3">Shifts : *</label>
        <div class="col-xs-9">
          <div *ngIf="isFallbackSlab" class="alert alert-info fallback-shift-info-strip" role="status">
            <ng-container *ngTemplateOutlet="fallbackShiftInfoText"></ng-container>
          </div>
          <div *ngIf="isFallbackSlab && defaultShiftsFetchedAndEmpty" class="default-shifts-missing">
            <p class="text-warning">Default shift is missing for this city &amp; mode.</p>
            <button type="button" class="btn btn-primary" *ngIf="!isViewMode"
                    (click)="router.navigate(['/shift/create'])">
              Create default shift
            </button>
          </div>
          <div *ngIf="isFallbackShiftsReadonlyBox()" class="fallback-shift-pseudo-select">
            <div class="fallback-shift-pseudo-container">
              <div class="fallback-shift-pseudo-value-wrap">
                <div class="fallback-shift-pseudo-value">
                  <span class="fallback-shift-pseudo-icon" aria-hidden="true">×</span>
                  <span class="fallback-shift-pseudo-label">{{ getFallbackShiftDisplayName() }}</span>
                </div>
              </div>
              <div class="fallback-shift-pseudo-arrow" aria-hidden="true">
                <span class="fallback-shift-pseudo-arrow-triangle"></span>
              </div>
            </div>
          </div>
          <ng-select *ngIf="!isFallbackShiftsReadonlyBox() && (!defaultShiftsFetchedAndEmpty || !isFallbackSlab)"
                      [(ngModel)]="params.shift" name="shift"
                      placeholder="Shifts"
                      [multiple]="true" [clearable]="false"
                      (change)="onShiftChange()"
                      [disabled]="!params.serviceTypes || params.serviceTypes.length === 0 || isViewMode"
                      style="font-size: 16px;">
            <ng-option *ngFor="let shift of shifts" [value]="shift">{{ shift }}</ng-option>
          </ng-select>
        </div>
      </div>

      <!-- New Shift Name -->
      <div class="form-group" *ngIf="!isGeoSlabPage && shiftSelection === 'new'">
        <label class="control-label col-xs-3" for="newShiftNameInput">New Shift Name : *</label>
        <div class="col-xs-9">
          <div *ngIf="isFallbackSlab" class="alert alert-info fallback-shift-info-strip" role="status">
            <ng-container *ngTemplateOutlet="fallbackShiftInfoText"></ng-container>
          </div>
          <input id="newShiftNameInput" type="text" class="form-control" name="newShift" [(ngModel)]="params.shift"
                 placeholder="Enter shift name" [readonly]="isViewMode">
        </div>
      </div>

      <!-- Start Date -->
      <div class="form-group">
        <label class="control-label col-xs-3">Start Date : *</label>
        <div class="col-xs-5 start-date-wrap" (click)="!isViewMode && openStartDatePicker()">
          <input #startDateInput type="date" class="form-control" name="startDate" [(ngModel)]="params.startDate"
                 [readonly]="isViewMode">
        </div>
      </div>

      <!-- Slab Message -->
      <div class="form-group">
        <label class="control-label col-xs-3">Slab Message : *</label>
        <div class="col-xs-9">
          <input type="text" class="form-control" name="slabMessage" [(ngModel)]="params.slabMessage"
                 placeholder="Enter slab message" [readonly]="isViewMode">
        </div>
      </div>

      <!-- Category -->
      <div class="form-group">
        <label class="control-label col-xs-3">Category for slab : *</label>
        <div class="col-xs-9">
          <ng-select [(ngModel)]="category" name="category" placeholder="Category"
                      (change)="clearSlabData($event)" [clearable]="false"
                      [disabled]="isViewMode"
                      style="font-size: 16px;">
            <ng-option *ngFor="let cat of categories" [value]="cat">{{ cat }}</ng-option>
          </ng-select>
        </div>
      </div>

      <div class="form-group" *ngIf="isGeoSlabPage">
        <label class="control-label col-xs-3">Radius : *</label>
        <div class="col-xs-9">
          <input type="number" class="form-control" name="geoFenceRadius"
                 [(ngModel)]="geoFenceRadius" placeholder="Enter radius" min="1" step="1"
                 inputmode="numeric" pattern="[0-9]*"
                 (keydown)="onGeoSlabRadiusKeydown($event)"
                 (input)="onGeoSlabRadiusInput($event)"
                 [readonly]="isViewMode">
        </div>
      </div>
      <div class="form-group" *ngIf="isGeoSlabPage">
        <label class="control-label col-xs-3">Amount : *</label>
        <div class="col-xs-9">
          <input type="number" class="form-control" name="geoFenceAmount"
                 [(ngModel)]="geoFenceAmount" placeholder="Enter amount" min="0" step="any"
                 [readonly]="isViewMode">
        </div>
      </div>

      <!-- Exclude Incentive Types -->
      <div class="form-group">
        <label class="control-label col-xs-3">Exclude Incentive Types :</label>
        <div class="col-xs-9">
          <ng-select [(ngModel)]="params.excludeIncentiveTypes" name="excludeIncentiveTypes"
                      placeholder="Incentive types to exclude"
                      [multiple]="true" [clearable]="false"
                      [disabled]="isViewMode"
                      style="font-size: 16px;">
            <ng-option value="daily">daily</ng-option>
            <ng-option value="weekly">weekly</ng-option>
            <ng-option value="adhoc">adhoc</ng-option>
          </ng-select>
          <small class="text-muted">Incentive types to exclude</small>
        </div>
      </div>

      <!-- Earning Model -->
      <div class="form-group" *ngIf="earningModels.length > 0 || ((isViewMode || actionTitle === 'Duplicate') && params.earningModel)">
        <label class="control-label col-xs-3">Earning Model : *</label>
        <div class="col-xs-9">
          <ng-select [(ngModel)]="params.earningModel" name="earningModel" placeholder="Earning Model"
                      (change)="earningModelChanged()" [clearable]="false"
                      [disabled]="isViewMode"
                      style="font-size: 16px;">
            <ng-option *ngFor="let model of earningModels" [value]="model">{{ model }}</ng-option>
          </ng-select>
        </div>
      </div>

      <div class="form-group" *ngIf="minimumGuaranteeFlowLoadingMessage">
        <div class="col-xs-offset-3 col-xs-9">
          <div class="alert alert-info minimum-guarantee-loading-status" role="status">
            {{ minimumGuaranteeFlowLoadingMessage }}
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="params.earningModel === 'minimum_guarantee' && showMinimumGuaranteeBanner && !isViewMode">
        <div class="col-xs-offset-3 col-xs-9">
          <div class="alert alert-warning" role="alert">
            <button type="button" class="close" aria-label="Close" (click)="dismissMinimumGuaranteeBanner()"></button>
            <div>
              {{ minimumGuaranteeBannerMessage }}
              <div class="minimum-guarantee-view-slabs-link-wrap">
                <a href="#" class="mg-view-slabs-link" (click)="openMinimumGuaranteeSlabsInNewWindow($event)">
                  View slabs for this shift (Minimum Guarantee)
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="params.earningModel === 'minimum_guarantee' && minimumGuaranteeSlabsLookupError">
        <div class="col-xs-offset-3 col-xs-9">
          <div class="alert alert-danger mg-slabs-lookup-status" role="alert">
            <p class="mg-slabs-lookup-error-text">{{ minimumGuaranteeSlabsLookupErrorMessage }}</p>
            <button type="button" class="btn btn-default btn-sm" (click)="retryMinimumGuaranteeSlabsLookup()">
              Retry
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="params.earningModel === 'minimum_guarantee' && params.minimumGuaranteeDetails && !minimumGuaranteeSlabsLookupPending && !minimumGuaranteeSlabsLookupError">
        <div class="form-group">
          <div class="col-xs-offset-3 col-xs-9">
            <small class="text-muted" *ngIf="isMinimumGuaranteeReadOnly">
              Auto-filled from an existing slab for this shift. Fields are locked.
            </small>
            <small class="text-muted" *ngIf="!isMinimumGuaranteeReadOnly">
              Enter Minimum Guarantee values for this shift.
            </small>
          </div>
        </div>

        <div class="form-group" *ngIf="showMinimumGuaranteeMicroCorridorField">
          <label class="control-label col-xs-3">MicroCorridor :</label>
          <div class="col-xs-9">
            <div *ngIf="!microCorridorsLoading && microCorridorsError" class="alert alert-danger mg-slabs-lookup-status" role="alert">
              <p class="mg-slabs-lookup-error-text">{{ microCorridorsErrorMessage }}</p>
              <button *ngIf="microCorridorsErrorCanRetry" type="button" class="btn btn-default btn-sm" (click)="retryMicroCorridorLookup()">
                Retry
              </button>
            </div>
            <ng-select *ngIf="!microCorridorsLoading && !microCorridorsError && microCorridors.length > 0"
                       [(ngModel)]="selectedMicroCorridorIds"
                       name="minimumGuaranteeMicroCorridor"
                       placeholder="MicroCorridor"
                       [multiple]="true"
                       [clearable]="false"
                       [disabled]="isMicroCorridorSelectionDisabled()"
                       (ngModelChange)="onMicroCorridorSelectionChange($event)"
                       style="font-size: 16px;">
              <ng-option *ngFor="let mc of microCorridors" [value]="mc.id">{{ mc.name }}</ng-option>
            </ng-select>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-xs-3">MG Eligibility Orders : *</label>
          <div class="col-xs-9">
            <input class="form-control" type="number" min="0"
                   name="mgEligibilityOrders"
                   [(ngModel)]="params.minimumGuaranteeDetails.eligibilityCriteria.orders"
                   [readonly]="isViewMode || isMinimumGuaranteeReadOnly">
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-xs-3">Minimum Guarantee Amount : *</label>
          <div class="col-xs-9">
            <input class="form-control" type="number" min="0"
                   name="minimumGuaranteeAmount"
                   [(ngModel)]="params.minimumGuaranteeDetails.minimumGuaranteeAmount"
                   [readonly]="isViewMode || isMinimumGuaranteeReadOnly">
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-xs-3">Perception Amount :</label>
          <div class="col-xs-9">
            <input class="form-control" type="number" min="0"
                   name="perceptionAmount"
                   [(ngModel)]="params.minimumGuaranteeDetails.perceptionAmount"
                   [readonly]="isViewMode || isMinimumGuaranteeReadOnly">
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-xs-3">MG Slots : *</label>
          <div class="col-xs-9">
            <small class="text-muted">
              At least one time slot is required. You may add up to {{ minimumGuaranteeSlotCount }}
              slot{{ minimumGuaranteeSlotCount === 1 ? '' : 's' }} (dashboard limit).
            </small>
            <div *ngIf="!isViewMode && !isMinimumGuaranteeReadOnly" class="mg-slot-actions">
              <button type="button"
                      class="btn btn-primary btn-sm mg-add-time-slot-btn"
                      (click)="addMinimumGuaranteeSlot()"
                      [disabled]="params.minimumGuaranteeDetails.slots.length >= minimumGuaranteeSlotCount || isMinimumGuaranteeSlotTimeLocked()">
                Add time slot
              </button>
            </div>
          </div>
        </div>

        <div class="form-group" *ngFor="let mgSlot of params.minimumGuaranteeDetails.slots; let mgSlotIdx = index">
          <label class="control-label col-xs-3">Slot {{ mgSlotIdx + 1 }}</label>
          <div class="col-xs-7">
            <div class="row slab-time-row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="form-group">
                  <label>Minimum Guarantee Slot Start Time</label>
                  <input type="time" class="form-control"
                         [name]="'mgSlotStart_' + mgSlotIdx"
                         [(ngModel)]="mgSlot.startTime"
                         step="60"
                         pattern="[0-9]{2}:[0-9]{2}"
                         [disabled]="isMinimumGuaranteeSlotTimeLocked()"
                         (ngModelChange)="mgSlot.startTime = convertTo24Hour($event)">
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="form-group">
                  <label>Minimum Guarantee Slot End Time</label>
                  <input type="time" class="form-control"
                         [name]="'mgSlotEnd_' + mgSlotIdx"
                         [(ngModel)]="mgSlot.endTime"
                         step="60"
                         pattern="[0-9]{2}:[0-9]{2}"
                         [disabled]="isMinimumGuaranteeSlotTimeLocked()"
                         (ngModelChange)="mgSlot.endTime = convertTo24Hour($event)">
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-2">
            <div class="form-group mg-slot-remove-wrap">
              <label class="mg-slot-remove-label">&nbsp;</label>
              <button type="button" class="btn btn-sm btn-link text-danger"
                      *ngIf="!isViewMode && !isMinimumGuaranteeReadOnly && selectedMicroCorridorIds.length === 0 && params.minimumGuaranteeDetails.slots.length > 1"
                      (click)="removeMinimumGuaranteeSlot(mgSlotIdx)">
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Is Salaried -->
      <div class="form-group" *ngIf="params.earningModel === 'access_fee'">
        <div class="control-label col-xs-3 default-slab-label-col">
          <span for="isSalaried">Salaried:</span>
          <div>
            <span class="text-danger">Enable for rental captains to whom access fee amount should not be deducted</span>
          </div>
        </div>
        <div class="col-xs-9">
          <input type="checkbox" id="isSalaried" name="isSalaried" [(ngModel)]="params.isSalaried"
                 [disabled]="isViewMode">
        </div>
      </div>

      <!-- Pool Size (shown only for services whose orderType is configured for pool slabs) -->
      <div class="form-group" *ngIf="showPoolFields()">
        <label class="control-label col-xs-3">Pool Size:</label>
        <div class="col-xs-9">
          <input type="number" class="form-control" name="poolSize" [(ngModel)]="params.poolSize"
                 (ngModelChange)="onPoolSizeChange()" min="2" placeholder="Enter pool size (e.g., 2, 3, 4)"
                 [disabled]="isViewMode">
          <p class="help-block">Number of expected orders in the pool (minimum 2)</p>
        </div>
      </div>

      <!-- Pool Multipliers -->
      <div class="form-group" *ngIf="showPoolFields() && params.poolSize && params.poolSize >= 2">
        <label class="control-label col-xs-3">Pool Multipliers (%):</label>
        <div class="col-xs-9">
          <div *ngFor="let position of getPoolMultiplierPositions()" class="pool-multiplier-row" style="margin-bottom: 10px;">
            <label style="display: inline-block; width: 150px; margin-right: 10px;">
              Order Position {{ position }}:
            </label>
            <input type="number" class="form-control" style="display: inline-block; width: 200px;"
                   [value]="getPoolMultiplierValue(position)"
                   (input)="setPoolMultiplierValue(position, $event.target.value)"
                   min="0" max="100" step="0.1" placeholder="e.g., 75.0"
                   [disabled]="isViewMode">
            <span style="margin-left: 5px;">%</span>
          </div>
          <p class="help-block">Multiplier percentage to apply when this order position is empty</p>
        </div>
      </div>

      <!-- Commission (non-order) -->
      <div class="form-group" *ngIf="category !== 'order' && (showPercentCommission() || showRupeesCommission())">
        <label class="control-label col-xs-3">Commission : *</label>
        <div class="col-xs-9">
          <label class="radio-inline" *ngIf="showPercentCommission()">
            <input type="radio" name="commissionType" [(ngModel)]="params.commissionType" value="percent"
                   (ngModelChange)="onCommissionTypeChange()" [disabled]="isViewMode"> percent
          </label>
          <label class="radio-inline" [style.margin-left.px]="showPercentCommission() ? 20 : 0"
                 *ngIf="showRupeesCommission()">
            <input type="radio" name="commissionType" [(ngModel)]="params.commissionType" value="rupees"
                   (ngModelChange)="onCommissionTypeChange()" [disabled]="isViewMode"> rupees
          </label>
        </div>
      </div>
      <div class="form-group"
           *ngIf="category !== 'order' && params.commissionType && params.commissionType.length > 0 && (showPercentCommission() || showRupeesCommission())">
        <label class="control-label col-xs-3">Commission Amount : *</label>
        <div class="col-xs-9">
          <input type="number" class="form-control" name="commissionAmount" [(ngModel)]="params.commissionAmount"
                 [disabled]="category === 'distance' || isViewMode">
          <p class="help-block" *ngIf="shouldShowFlatCommissionDeductions()">
            {{ flatCommissionInclusiveAmountNote }}
          </p>
        </div>
      </div>

      <div *ngIf="shouldShowFlatCommissionDeductions() && !isViewMode">
        <div class="form-group">
          <label class="control-label col-xs-3">Taxes (%) :</label>
          <div class="col-xs-9">
            <input type="text" class="form-control flat-commission-readonly" [value]="flatCommissionTaxDisplay"
                   readonly>
            <p class="help-block" *ngIf="flatCommissionDeductionsLoading">Loading tax details...</p>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-xs-3">Platform Fees (INR) :</label>
          <div class="col-xs-9">
            <input type="text" class="form-control flat-commission-readonly" [value]="flatCommissionPlatformFeeDisplay"
                   readonly>
            <p class="help-block" *ngIf="flatCommissionDeductionsLoading">Loading platform fee details...</p>
            <p class="help-block text-danger" *ngIf="flatCommissionDeductionsError">
              {{ fetchTaxesAndOrPlatformFeeErrorMessage }}
              <button type="button" class="btn btn-link btn-sm" (click)="fetchFlatCommissionDeductions()">Retry</button>
            </p>
          </div>
        </div>
      </div>

      <!-- ─── FIRST / LAST MILE THRESHOLD ──────────────────────────────── -->

      <div class="form-group" *ngIf="category || (isViewMode && (thresholdDistanceFM != null || thresholdFareFM != null))">
        <label class="control-label col-xs-3">First-mile threshold distance (km):</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="0" [(ngModel)]="thresholdDistanceFM"
                 name="thresholdDistanceFM" [readonly]="isViewMode">
        </div>
      </div>

      <div class="form-group" *ngIf="category || (isViewMode && (thresholdDistanceFM != null || thresholdFareFM != null))">
        <label class="control-label col-xs-3">Per km fare after first-mile threshold distance:</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="0" [(ngModel)]="thresholdFareFM"
                 name="thresholdFareFM" [readonly]="isViewMode">
        </div>
      </div>

      <div class="form-group" *ngIf="thresholdDistanceFM || thresholdFareFM">
        <label class="control-label col-xs-3">Maximum first-mile compensation (INR) *</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="1" max="99" [(ngModel)]="maxCompensationFM"
                 name="maxCompensationFM" [readonly]="isViewMode">
        </div>
      </div>

      <div class="form-group" *ngIf="thresholdDistanceFM || thresholdFareFM">
        <label class="control-label col-xs-3">Minimum first-mile compensation (INR) *</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="0" max="99" [(ngModel)]="minCompensationFM"
                 name="minCompensationFM" [readonly]="isViewMode">
        </div>
      </div>

      <div class="form-group" *ngIf="category === 'order'">
        <label class="control-label col-xs-3">Last-mile threshold distance (km):</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="0" [(ngModel)]="thresholdDistanceLM"
                 name="thresholdDistanceLM" [readonly]="isViewMode">
        </div>
      </div>

      <div class="form-group" *ngIf="category === 'order'">
        <label class="control-label col-xs-3">Per km fare after last-mile threshold distance:</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="0" [(ngModel)]="thresholdFareLM"
                 name="thresholdFareLM" [readonly]="isViewMode">
        </div>
      </div>

      <div class="form-group" *ngIf="canSetDesiredCustomerPpkm">
        <label class="control-label col-xs-3">Minimum desired customer PPKM:</label>
        <div class="col-xs-9">
          <input class="form-control" type="number" min="0" [(ngModel)]="desiredCustomerPpkm"
                 name="desiredCustomerPpkm" [readonly]="isViewMode">
        </div>
      </div>

      <!-- ─── DISTANCE-SPECIFIC ─────────────────────────────────────────── -->

      <div *ngIf="category === 'distance' || (isViewMode && (params.earningModel === 'distance' || params.minimumPayout != null || (params.peakSlab && params.peakSlab.slabData) || timeBasedSlabs.length > 0))">
        <div class="form-group">
          <label class="control-label col-xs-3">Minimum distance fare:</label>
          <div class="col-xs-9">
            <input class="form-control" type="number" min="0" [(ngModel)]="params.minimumPayout"
                   name="minimumPayout" [readonly]="isViewMode">
          </div>
        </div>

        <!-- Time-based payout -->
        <div class="form-group">
        <!-- <div class="form-group" *ngIf="!isViewMode"> -->
          <label class="control-label col-xs-3">Time Based Payout</label>
          <div class="col-xs-9" *ngIf="!isViewMode">
            <button type="button" class="btn btn-primary btn-md" (click)="addTimeBasedSlab()">
              <i class="fa fa-plus"></i> Add Slab
            </button>
          </div>
        </div>
        <div *ngFor="let tb of timeBasedSlabs; let tbi = index" class="row time-based-slab-row">
          <div style="float:left;margin:1%">
            <label>Start time</label>
            <input type="time" class="form-control" [(ngModel)]="tb.startTime" [name]="'tbStart' + tbi"
                   step="60" pattern="[0-9]{2}:[0-9]{2}"
                   [readonly]="isViewMode"
                   (ngModelChange)="tb.startTime = convertTo24Hour($event)">
          </div>
          <div style="float:left;margin:1%">
            <label>End time</label>
            <input type="time" class="form-control" [(ngModel)]="tb.endTime" [name]="'tbEnd' + tbi"
                   step="60" pattern="[0-9]{2}:[0-9]{2}"
                   [readonly]="isViewMode"
                   (ngModelChange)="tb.endTime = convertTo24Hour($event)">
          </div>
          <div style="float:left;margin:1%">
            <label>Type</label>
            <select class="form-control" [(ngModel)]="tb.rules[0].type" [name]="'tbType' + tbi"
                    [disabled]="isViewMode">
              <option *ngFor="let rt of timeBasedSlabRuleTypes" [value]="rt">{{ rt }}</option>
            </select>
          </div>
          <div style="float:left;margin:1%">
            <label>Value</label>
            <input class="form-control" type="number" min="0" [(ngModel)]="tb.rules[0].value"
                   [name]="'tbValue' + tbi" [readonly]="isViewMode">
          </div>
          <div style="float:left;margin:1%" *ngIf="!isViewMode">
            <label>Remove</label>
            <button type="button" class="form-control btn btn-danger btn-xs"
                    (click)="removeTimeBasedSlab(tbi)">
              <i class="fa fa-trash"></i> Remove
            </button>
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           NON-BATCHED SLAB DETAILS
           ═══════════════════════════════════════════════════════════════════ -->

      <div id="nonBatchedDetails">
        <br>
        <h2 *ngIf="category === 'order'" class="section-title">Non Batched Slab Details</h2>

        <!-- Commission for order category (non-batched) -->
        <div class="form-group" *ngIf="category === 'order' && (showPercentCommission() || showRupeesCommission())">
          <label class="control-label col-xs-3">Commission : *</label>
          <div class="col-xs-9">
            <label class="radio-inline" *ngIf="showPercentCommission()">
              <input type="radio" name="nbCommissionType" [(ngModel)]="params.commissionType" value="percent"
                     [disabled]="isViewMode"> percent
            </label>
            <label class="radio-inline" [style.margin-left.px]="showPercentCommission() ? 20 : 0"
                   *ngIf="showRupeesCommission()">
              <input type="radio" name="nbCommissionType" [(ngModel)]="params.commissionType" value="rupees"
                     [disabled]="isViewMode"> rupees
            </label>
          </div>
        </div>
        <div class="form-group"
             *ngIf="category === 'order' && params.commissionType && params.commissionType.length > 0 && (showPercentCommission() || showRupeesCommission())">
          <label class="control-label col-xs-3">Commission Amount : *</label>
          <div class="col-xs-4">
            <input type="number" class="form-control" name="nbCommissionAmount"
                   [(ngModel)]="params.commissionAmount" [readonly]="isViewMode">
          </div>
        </div>

        <!-- ── PEAK SLAB ─────────────────────────────────────────────────── -->
        <!-- <ng-container *ngIf="(category && category !== 'cm') || (isViewMode && params.peakSlab)"> -->
        <ng-container *ngIf="category && category !== 'cm'">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'peakSlab',
            label: 'Peak Slab',
            showPerOrder: (category === 'order') || (isViewMode && !category && params.earningModel !== 'distance'),
            showPerKm: (category === 'distance') || (isViewMode && params.earningModel === 'distance'),
            disableTime: (category === 'distance') || (isViewMode && params.earningModel === 'distance')
          }"></ng-container>
        </ng-container>

        <!-- ── NON-PEAK SLAB ──────────────────────────────────────────────── -->
        <ng-container *ngIf="category === 'order'">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'nonPeakSlab',
            label: 'Non Peak Slab',
            showPerOrder: true,
            showPerKm: false
          }"></ng-container>
        </ng-container>

        <!-- ── FLEXIBLE SLAB ──────────────────────────────────────────────── -->
        <ng-container *ngIf="category === 'order'">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'flexibleSlab',
            label: 'Flexible Slab',
            showPerOrder: true,
            showPerKm: false
          }"></ng-container>
        </ng-container>

        <!-- ── NIGHT SLAB ─────────────────────────────────────────────────── -->
        <ng-container *ngIf="category === 'order'">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'nightSlab',
            label: 'Night Slab',
            showPerOrder: true,
            showPerKm: false
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="category === 'order' && actionTitle !== 'Add' && params.nonPeakSlab?.timeData?.length">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'nonPeakSlab',
            label: 'Non Peak Slab',
            showPerOrder: true,
            showPerKm: false
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="category === 'order' && actionTitle !== 'Add' && params.flexibleSlab?.timeData?.length">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'flexibleSlab',
            label: 'Flexible Slab',
            showPerOrder: true,
            showPerKm: false
          }"></ng-container>
        </ng-container>

        <ng-container *ngIf="category === 'order' && actionTitle !== 'Add' && params.nightSlab?.timeData?.length">
          <ng-container *ngTemplateOutlet="slabSection; context: {
            slabKey: 'nightSlab',
            label: 'Night Slab',
            showPerOrder: true,
            showPerKm: false
          }"></ng-container>
        </ng-container>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           BATCHED SLAB DETAILS (only for order category)
           ═══════════════════════════════════════════════════════════════════ -->

      <div *ngIf="category === 'order'">
        <br>
        <h2 class="section-title">Batched Slab Details</h2>

        <!-- ── FIRST ORDER ─────────────────────────────────────────────── -->
        <h3 class="sub-section-title">First Order</h3>

        <div class="form-group">
          <label class="control-label col-xs-3">Category for Batched First Order : *</label>
          <div class="col-xs-3">
            <select name="batchedFirstOrderCategory" [(ngModel)]="BatchedFirstOrderCategory" class="form-control"
                    [disabled]="isViewMode">
              <option value="">-- Select --</option>
              <option *ngFor="let cat of batchedFirstOrderCategories" [value]="cat">{{ cat }}</option>
            </select>
          </div>
        </div>

        <div class="form-group" *ngIf="showPercentCommission() || showRupeesCommission()">
          <label class="control-label col-xs-3">Commission Type : *</label>
          <div class="col-xs-9">
            <label class="radio-inline" *ngIf="showPercentCommission()">
              <input type="radio" name="commissionTypeBFO" [(ngModel)]="params.commissionTypeBatchedFirstOrder"
                     value="percent" [disabled]="isViewMode"> percent
            </label>
            <label class="radio-inline" [style.margin-left.px]="showPercentCommission() ? 20 : 0"
                   *ngIf="showRupeesCommission()">
              <input type="radio" name="commissionTypeBFO" [(ngModel)]="params.commissionTypeBatchedFirstOrder"
                     value="rupees" [disabled]="isViewMode"> rupees
            </label>
          </div>
        </div>
        <div class="form-group"
             *ngIf="params.commissionTypeBatchedFirstOrder && params.commissionTypeBatchedFirstOrder.length > 0 && (showPercentCommission() || showRupeesCommission())">
          <label class="control-label col-xs-3">Commission Amount (First Order) : *</label>
          <div class="col-xs-4">
            <input type="number" class="form-control" name="commissionAmountBFO"
                   [(ngModel)]="params.commissionAmountBatchedFirstOrder" [readonly]="isViewMode">
          </div>
        </div>

        <!-- Show all slabs for First Order -->
        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'peakSlabBatchedFirstOrder',
          label: 'Peak Slab (First Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'nonPeakSlabBatchedFirstOrder',
          label: 'Non Peak Slab (First Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'flexibleSlabBatchedFirstOrder',
          label: 'Flexible Slab (First Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'nightSlabBatchedFirstOrder',
          label: 'Night Slab (First Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <!-- ── NEXT ORDER ──────────────────────────────────────────────── -->
        <h3 class="sub-section-title">Next Order</h3>

        <div class="form-group">
          <label class="control-label col-xs-3">Category for Batched Next Order : *</label>
          <div class="col-xs-3">
            <select name="batchedNextOrderCategory" [(ngModel)]="BatchedNextOrderCategory" class="form-control"
                    [disabled]="isViewMode">
              <option value="">-- Select --</option>
              <option *ngFor="let cat of batchedNextOrderCategories" [value]="cat">{{ cat }}</option>
            </select>
          </div>
        </div>

        <div class="form-group" *ngIf="showPercentCommission() || showRupeesCommission()">
          <label class="control-label col-xs-3">Commission Type : *</label>
          <div class="col-xs-9">
            <label class="radio-inline" *ngIf="showPercentCommission()">
              <input type="radio" name="commissionTypeBNO" [(ngModel)]="params.commissionTypeBatchedNextOrder"
                     value="percent" [disabled]="isViewMode"> percent
            </label>
            <label class="radio-inline" [style.margin-left.px]="showPercentCommission() ? 20 : 0"
                   *ngIf="showRupeesCommission()">
              <input type="radio" name="commissionTypeBNO" [(ngModel)]="params.commissionTypeBatchedNextOrder"
                     value="rupees" [disabled]="isViewMode"> rupees
            </label>
          </div>
        </div>
        <div class="form-group"
             *ngIf="params.commissionTypeBatchedNextOrder && params.commissionTypeBatchedNextOrder.length > 0 && (showPercentCommission() || showRupeesCommission())">
          <label class="control-label col-xs-3">Commission Amount (Next Order) : *</label>
          <div class="col-xs-4">
            <input type="number" class="form-control" name="commissionAmountBNO"
                   [(ngModel)]="params.commissionAmountBatchedNextOrder" [readonly]="isViewMode">
          </div>
        </div>

        <!-- Show all slabs for Next Order -->
        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'peakSlabBatchedNextOrder',
          label: 'Peak Slab (Next Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'nonPeakSlabBatchedNextOrder',
          label: 'Non Peak Slab (Next Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'flexibleSlabBatchedNextOrder',
          label: 'Flexible Slab (Next Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>

        <ng-container *ngTemplateOutlet="slabSection; context: {
          slabKey: 'nightSlabBatchedNextOrder',
          label: 'Night Slab (Next Order)',
          showPerOrder: true,
          showPerKm: false
        }"></ng-container>
      </div>

      <!-- ─── ACTION BUTTONS ────────────────────────────────────────────── -->
      <div class="form-group row justify-end" style="margin-top:30px; margin-bottom:40px"
           *ngIf="!isViewMode">
        <div class="col-xs-offset-3 col-xs-9">
          <button type="button" class="btn btn-primary btn-lg" (click)="submitSlab()"
                  [disabled]="isSubmitDisabled">
            <span *ngIf="loadingIndicator">
              <i class="fa fa-spinner fa-spin"></i> Submitting...
            </span>
            <span *ngIf="!loadingIndicator">Submit Slab</span>
          </button>
          <button type="button" class="btn btn-default btn-lg" style="margin-left:20px"
                  routerLink="/slabs">
            Cancel
          </button>
        </div>
      </div>
      <div class="form-group row justify-end" style="margin-top:30px; margin-bottom:40px"
           *ngIf="isViewMode">
        <div class="col-xs-offset-3 col-xs-9">
          <button type="button" class="btn btn-primary btn-lg" *ngIf="isApprovalPreview && canApprove"
                  (click)="approveSlabRequest()" [disabled]="processingApprovalRequest">
            Approve
          </button>
          <button type="button" class="btn btn-danger btn-lg" style="margin-left:12px"
                  *ngIf="isApprovalPreview && canReject"
                  (click)="rejectSlabRequest()" [disabled]="processingApprovalRequest">
            Reject
          </button>
          <p class="help-block" *ngIf="isApprovalPreview && approvalActionMessage"
             style="display:inline-block; margin: 0 12px;">
            {{ approvalActionMessage }}
          </p>
          <button type="button" class="btn btn-default btn-lg" [style.margin-left]="isApprovalPreview ? '12px' : '0'"
                  (click)="goBackFromSlabView()">
            Back to list
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════
     CONFIRMATION MODAL
     ═══════════════════════════════════════════════════════════════════════ -->
<div class="modal-overlay" *ngIf="showConfirmationModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirm Slab Creation</h4>
      </div>
      <div class="modal-body">
        <div class="alert alert-warning" *ngIf="isGeoSlabPage" role="alert">
          Existing config for this hotspot and city is updated with the latest slab.
        </div>
        <p>Are you sure you want to create this slab?</p>

        <div class="existing-slab-block" *ngIf="isGeoSlabPage && existingGeoSlabs.length">
          <div class="existing-slab-list">
            <div class="existing-slab-list-header">
              Existing Geo Slab
            </div>
            <div class="existing-slab-list-scroll">
              <div class="existing-slab-item" *ngFor="let slab of existingGeoSlabs">
                <ng-container *ngTemplateOutlet="existingGeoSlabDetails; context: { $implicit: slab }"></ng-container>
              </div>
            </div>
          </div>
        </div>

        <div class="new-slab-block">
          <h5 *ngIf="isGeoSlabPage">New slab</h5>
        <table class="table table-condensed table-bordered confirmation-table">
          <tbody>
            <tr>
              <th>City</th><td>{{ selectedCities }}</td>
            </tr>
            <tr>
              <th>Services</th><td>{{ selectedServiceNames?.join(', ') }}</td>
            </tr>
            <tr *ngIf="!isGeoSlabPage">
              <th>Shift(s)</th>
              <td>{{ params.shift | json }}</td>
            </tr>
            <tr *ngIf="isGeoSlabPage">
              <th>Layer</th><td>{{ getGeoLayerTypeDisplayName() }}</td>
            </tr>
            <tr *ngIf="isGeoSlabPage">
              <th>{{ getGeoLayerTypeDisplayName() }}</th><td>{{ getGeoSlabLayerDisplayName() }}</td>
            </tr>
            <tr *ngIf="isGeoSlabPage">
              <th>Radius</th><td>{{ geoFenceRadius }}</td>
            </tr>
            <tr *ngIf="isGeoSlabPage">
              <th>Amount</th><td>{{ geoFenceAmount }}</td>
            </tr>
            <tr>
              <th>Start Date</th><td>{{ params.startDate }}</td>
            </tr>
            <tr *ngIf="params.endDate">
              <th>End Date</th><td>{{ params.endDate }}</td>
            </tr>
            <tr>
              <th>Category</th><td>{{ category }}</td>
            </tr>
            <tr *ngIf="params.earningModel">
              <th>Earning Model</th><td>{{ params.earningModel }}</td>
            </tr>
            <tr *ngIf="params.commissionType">
              <th>Commission Type</th><td>{{ params.commissionType }}</td>
            </tr>
            <tr *ngIf="params.commissionAmount != null">
              <th>Commission Amount</th><td>{{ params.commissionAmount }}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="cancelConfirmation()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveData()" [disabled]="loadingIndicator">
          <span *ngIf="loadingIndicator"><i class="fa fa-spinner fa-spin"></i> Saving...</span>
          <span *ngIf="!loadingIndicator">Confirm</span>
        </button>
      </div>
    </div>
  </div>
</div>
<app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>

<ng-template #existingGeoSlabDetails let-slab>
  <table class="table table-condensed table-bordered confirmation-table" style="background: #fff;">
    <tbody>
      <tr>
        <th>ID</th><td>{{ getExistingGeoSlabId(slab) }}</td>
      </tr>
      <tr>
        <th>City</th><td>{{ getExistingGeoSlabCity(slab) }}</td>
      </tr>
      <tr>
        <th>Service</th><td>{{ getExistingGeoSlabServiceNames(slab) }}</td>
      </tr>
      <tr>
        <th>Hotspot</th><td>{{ getExistingGeoSlabHotspot(slab) }}</td>
      </tr>
      <tr>
        <th>Shift(s)</th><td>{{ getExistingGeoSlabShifts(slab) }}</td>
      </tr>
      <tr>
        <th>Start Date</th><td>{{ slab.startDate || '—' }}</td>
      </tr>
      <tr *ngIf="slab.endDate">
        <th>End Date</th><td>{{ slab.endDate }}</td>
      </tr>
      <tr>
        <th>Earning Model</th><td>{{ slab.earningModel || '—' }}</td>
      </tr>
      <tr *ngIf="slab.commissionType">
        <th>Commission Type</th><td>{{ slab.commissionType }}</td>
      </tr>
      <tr *ngIf="slab.commissionAmount != null">
        <th>Commission Amount</th><td>{{ slab.commissionAmount }}</td>
      </tr>
      <tr>
        <th>Active</th><td>{{ slab.active === false ? 'No' : 'Yes' }}</td>
      </tr>
      <tr>
        <th>Radius</th><td>{{ getExistingGeoSlabRadiusValue(slab) }}</td>
      </tr>
      <tr>
        <th>Amount</th><td>{{ getExistingGeoSlabAmountValue(slab) }}</td>
      </tr>
    </tbody>
  </table>
  <div class="existing-slab-section" *ngFor="let section of getExistingGeoSlabSections(slab)">
    <h6>{{ section.label }}</h6>
    <table class="table table-condensed table-bordered confirmation-table" style="background: #fff;">
      <thead>
        <tr>
          <th>From</th>
          <th>To</th>
          <th>Per value</th>
          <th>Bonus</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of section.rows">
          <td>{{ row.fromValue != null ? row.fromValue : '—' }}</td>
          <td>{{ row.toValue != null ? row.toValue : '—' }}</td>
          <td>{{ row.minPerAmount != null ? row.minPerAmount : '—' }}</td>
          <td>{{ row.bonus != null ? row.bonus : '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<!-- ═══════════════════════════════════════════════════════════════════════
     SLAB SECTION TEMPLATE (reusable)
     ═══════════════════════════════════════════════════════════════════════ -->

<ng-template #slabSection let-slabKey="slabKey" let-label="label"
             let-showPerOrder="showPerOrder" let-showPerKm="showPerKm" let-disableTime="disableTime">
  <div class="slab-section" *ngIf="params[slabKey]">
    <hr>
    <div class="row">
      <h3 class="control-label col-xs-3">{{ label }}</h3>
    </div>
    <br>

    <!-- Time Data buttons (hidden when time is hardcoded/disabled) -->
    <div class="row slab-buttons-row" *ngIf="!disableTime && !isViewMode">
      <div class="col-md-offset-2 col-md-10">
        <button type="button" class="btn btn-primary btn-md"
                (click)="addSlabTime(slabKey)">Time Data</button>
        <button type="button" class="btn btn-danger btn-md" style="margin-left:5px"
                (click)="removeDataFromSlab(slabKey, 'time', params[slabKey].timeData.length - 1)"
                [disabled]="!params[slabKey].timeData || params[slabKey].timeData.length === 0">
          <i class="fa fa-trash"></i>&nbsp; Remove Time Data
        </button>
      </div>
    </div>
    <br>

    <!-- Time Data rows -->
    <div *ngFor="let td of params[slabKey].timeData; let ti = index"
         class="row slab-time-row">
      <div class="col-md-offset-2 col-md-10">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group">
              <label>From time</label>
              <input type="time" class="form-control" [(ngModel)]="td.fromTime"
                     [name]="slabKey + '_fromTime_' + ti"
                     [disabled]="disableTime || isViewMode"
                     step="60"
                     pattern="[0-9]{2}:[0-9]{2}"
                     (ngModelChange)="td.fromTime = convertTo24Hour($event)">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group">
              <label>To time</label>
              <input type="time" class="form-control" [(ngModel)]="td.toTime"
                     [name]="slabKey + '_toTime_' + ti"
                     [disabled]="disableTime || isViewMode"
                     step="60"
                     pattern="[0-9]{2}:[0-9]{2}"
                     (ngModelChange)="td.toTime = convertTo24Hour($event)">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Slab Data buttons -->
    <div class="row slab-buttons-row" *ngIf="!isViewMode">
      <div class="col-md-offset-2 col-md-10">
        <button type="button" class="btn btn-primary btn-md"
                (click)="addSlabData(slabKey)">Add Slab Data</button>
        <button type="button" class="btn btn-danger btn-md" style="margin-left:5px"
                (click)="removeDataFromSlab(slabKey, 'slab', params[slabKey].slabData.slabs.length - 1)">
          <i class="fa fa-trash"></i>&nbsp; Remove Slab Data
        </button>
      </div>
    </div>
    <br>

    <!-- Slab Data rows -->
    <div *ngFor="let sd of params[slabKey].slabData.slabs; let si = index"
         class="row slab-data-row">
      <!-- hidden slabTitle (auto-set to index) -->
      <input type="hidden" [(ngModel)]="sd.slabTitle" [name]="slabKey + '_slabTitle_' + si"
             [ngModelOptions]="{standalone: true}">
      <div class="col-md-offset-2 col-md-10">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-2">
            <div class="form-group">
              <label>From value</label>
              <input class="form-control" type="number" [(ngModel)]="sd.fromValue"
                     [name]="slabKey + '_fromValue_' + si"
                     [readonly]="isViewMode"
                     (ngModelChange)="si > 0 && params[slabKey].slabData.slabs[si-1] ? params[slabKey].slabData.slabs[si-1].toValue = sd.fromValue : null">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2">
            <div class="form-group">
              <label>To value</label>
              <input class="form-control" type="number" [(ngModel)]="sd.toValue"
                     [name]="slabKey + '_toValue_' + si"
                     [readonly]="isViewMode"
                     (ngModelChange)="params[slabKey].slabData.slabs[si+1] ? params[slabKey].slabData.slabs[si+1].fromValue = sd.toValue : null">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2" *ngIf="showPerOrder">
            <div class="form-group">
              <label>Per Order</label>
              <input class="form-control" type="number" [(ngModel)]="sd.minPerAmount"
                     [name]="slabKey + '_perOrder_' + si"
                     [disabled]="si !== 0 || isViewMode"
                     (ngModelChange)="si === 0 ? updateMinPerAmount2(slabKey, slabKey, $event) : null">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2" *ngIf="showPerKm">
            <div class="form-group">
              <label>Per KM</label>
              <input class="form-control" type="number" [(ngModel)]="sd.minPerAmount"
                     [name]="slabKey + '_perKm_' + si" [readonly]="isViewMode">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2">
            <div class="form-group">
              <label>Bonus</label>
              <input class="form-control" type="number" [(ngModel)]="sd.bonus"
                     [name]="slabKey + '_bonus_' + si" [readonly]="isViewMode">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
